/**
 * Static list of comment-filter authors: TipRanks staff who have the newsPortal
 * admin permission AND exist in the tipranks_data `authors` collection. Used to
 * populate the "Author" filter on the admin comments page. Filtering by author
 * maps a slug → the posts that author wrote → comments on those posts (comments
 * store `postSlug`, not the author).
 *
 * Generated from prod via apps/admin/api/scripts/build-comment-authors.ts
 * (newsPortal users ∩ authors, matched by name; two nickname/hyphen cases —
 * Eddie/Edward Pan and Gilan Miller-Gertz — added manually). Regenerate if the
 * author roster changes. `slug` is the author document `_id`, which equals
 * `posts.author`.
 */
export interface CommentAuthorOption {
  /** Author document `_id` — matches `posts.author`. */
  slug: string;
  /** Display name (from the authors collection). */
  name: string;
}

export const COMMENT_AUTHORS: readonly CommentAuthorOption[] = [
  { slug: "annika-masranitipranks-com", name: "Annika Masrani" },
  { slug: "david-craik", name: "David Craik" },
  { slug: "edward-pan", name: "Eddie Pan" },
  { slug: "gilan-gertz", name: "Gilan Miller-Gertz" },
  { slug: "joel-bagloletipranks-com", name: "Joel Baglole" },
  { slug: "joy-iyke", name: "Joy Iyke" },
  { slug: "kirti-taktipranks-com", name: "Kirti Tak" },
  { slug: "polly-tal", name: "Polly Tal" },
  { slug: "radhika-saraogi", name: "Radhika Saraogi" },
  { slug: "ran-melamedtipranks-com", name: "Ran Melamed" },
  { slug: "shalu-saraf", name: "Shalu Saraf" },
  { slug: "sheryl-sheth", name: "Sheryl Sheth" },
  { slug: "sirisha-bhogaraju", name: "Sirisha Bhogaraju" },
  { slug: "solomon-oladipupo", name: "Solomon Oladipupo" },
  { slug: "vince-condarcuri", name: "Vince Condarcuri" },
] as const;
